import { Container } from '@bit/ui-common.ui-components/ss-components';
import { Row, Col, Menu } from 'antd';
import WhatsNew from './WhatsNew';
import Regulatory from './Regulatory';
import LegalNotice from './LegalNotice';
import Links from './Links';
import Faqs from './Faqs';
import ApplicationGuide from './ApplicationGuide';
import ContactAFSP from './ContactAFSP';
import HomeBadge from './HomeBadge';
import * as helpServices from '../../../redux/services/helpServices';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const { getDataType } = ssCommonUtils;

class HelpMenu extends React.Component {
    constructor(props) {
        super(props);
        const { services: { setHelpMenuActiveKey } } = props;
        setHelpMenuActiveKey('NEW');
    }

    componentDidMount() {
        const { services: { setHelpMenuActiveKey }, helpData, defaultTab } = this.props;
        if(defaultTab && helpData.activeKey !== defaultTab)
            setHelpMenuActiveKey(defaultTab);
    }

    getMenuTheme = type => {
        const
        { menuFull } = this.props,
        menuFullStyle = {
            fontWeight: 'bold',
            width: '100%',
            position: 'absolute',
            left: '0%',
        };

        switch(type) {
            case 'light': return menuFull ? {...menuFullStyle,
                backgroundColor: 'rgba(255, 255, 255, .90)'
            } : {
                padding: '0px 40px',
                background: 'linear-gradient(to left, ' +
                    'rgba(255, 255, 255, 0), ' +
                    'rgba(255, 255, 255, 1) 10%, ' +
                    'rgba(255, 255, 255, 1) 90%, ' +
                    'rgba(255, 255, 255, 0)' +
                ')'
            };

            case 'dark': return menuFull ? {...menuFullStyle,
                backgroundColor: 'rgba(35, 35, 35, .90)'
            } : {
                padding: '0px 40px',
                background: 'linear-gradient(to left, ' +
                    'rgba(35, 35, 35, 0), ' +
                    'rgba(35, 35, 35, 1) 10%, ' +
                    'rgba(35, 35, 35, 1) 90%, ' +
                    'rgba(35, 35, 35, 0)' +
                ')'
            };
            default: return {
                padding: '0px 40px',
                background: 'linear-gradient(to left, ' +
                    'rgba(255, 255, 255, 0), ' +
                    'rgba(255, 255, 255, 1) 10%, ' +
                    'rgba(255, 255, 255, 1) 90%, ' +
                    'rgba(255, 255, 255, 0)' +
                ')'
            };
        }
    }

    getFormatting = format => { switch(format) {
        case 'home-page': return {
            row: {
                gutter: 20,
                style: {
                    width: '90%',
                    transform: 'translateX(-50%)',
                    left: '18%',
                    position: 'absolute',
                    marginTop: '15px',
                    top: '45px',
                    bottom: '15px'
                }
            },
            colBadge: { style: {
                position: 'absolute',
                top: '0px'
            }},
            colContent: { style:{
                marginLeft: '370px'
            }}
        };

        default: return { row: null };
    }}

    render() {
        // Current theme options:
        // - light
        // - dark

        const
        { helpData, space, theme, portal, data, services, format } = this.props,
        view = data.find(d => d.key === helpData.activeKey),
        formatting = this.getFormatting(format),
        config = {
            space: space || 'lg',
            theme: theme || 'light',
            portal: (portal || 'c').toLowerCase(),
            format: format || 'default'
        };

        return (
            <div style={{ textAlign: 'center' }}>
                <Row type='flex' justify='center' align='middle'>
                    <Col>
                        <Menu
                            theme={config.theme}
                            mode='horizontal'
                            onClick={e => services.setHelpMenuActiveKey(e.key)}
                            selectedKeys={[ helpData.activeKey ]}
                            style={this.getMenuTheme(config.theme)}
                        >
                            {getDataType(data) !== 'Array' ? null : data.map(e => (
                                <Menu.Item key={e.key}>
                                    <span style={{ textShadow: 'rgba(0, 0, 0, .30) 1px 1px 0px' }}>
                                        {e.title}
                                    </span>
                                </Menu.Item>
                            ))}
                        </Menu>
                        <Row {...formatting.row} type='flex' justify='center' align='middle'>
                            {format !== 'home-page' ? null : (
                                <Col {...formatting.colBadge}>
                                    <HomeBadge />
                                </Col>
                            )}
                            <Col {...formatting.colContent}>
                                {view == null ? null : view.component(config)}
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Container({
    state: s => ({ helpData: s.helpData }),
    services: [ helpServices ]
},
class HelpLayout extends React.Component {
    constructor(props) { super(props); }

    sort = (a, b) => {
        if(a.order === b.order) return 0;
        else if(a.order < b.order) return -1;
        else return 1;
    }

    render = () => <HelpMenu {...this.props} data={[{
        key: 'NEW',
        title: 'Home',
        component: props => <WhatsNew {...props} sort={this.sort} />
    }, {
        key: 'REGULATORY',
        title: 'About the Regulation',
        component: props => <Regulatory {...props} sort={this.sort} />
    }, {
        key: 'LEGAL_NOTICE',
        title: 'Legal Notices',
        component: props => <LegalNotice {...props} sort={this.sort} />
    }, {
        key: 'FAQS',
        title: 'FAQs',
        component: props => <Faqs {...props} sort={this.sort} />
    }, {
        key: 'APPLICATION_GUIDE',
        title: 'User Guides',
        component: props => <ApplicationGuide {...props} sort={this.sort} />
    }, {
        key: 'LINKS',
        title: 'Links',
        component: props => <Links {...props} sort={this.sort} />
    }, {
        key: 'CONTACT_AFSP',
        title: 'Contact FTSP',
        component: props => <ContactAFSP {...props} sort={this.sort} />
    }]} />;
});
